<template>
    <qrcode-vue :value="value" :size="size" :margin="margin" :image-settings="logoSettings" level="H" />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import QrcodeVue from "qrcode.vue";
import type { ImageSettings } from "qrcode.vue";

export default defineComponent({
    name: "Qrcode",
    components: {
        QrcodeVue
    },
    props: {
        value: { type: String, required: false, default: "" },
        size: { type: Number, required: false, default: 250 },
        margin: { type: Number, required: false, default: 2 },
        logo: { type: Boolean, required: false, default: false },
    },
    computed: {
        logoSettings(): ImageSettings | undefined {
            if (!this.logo) return undefined;
            return { src: "/img/AirProMark.png", width: 48, height: 48, excavate: true };
        },
    },
});

</script>
